module.exports = __webpack_public_path__ + "static/media/Cognizant.23ed35be.png";